import React from "react";

const SRC = `${process.env.PUBLIC_URL || ""}/logo-omniverse.png`;

export function Logo({ size = 44, className = "", withText = false }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="omniverse-logo">
      <img
        src={SRC}
        alt="Omniverse — TCG Community"
        style={{ height: size, width: "auto" }}
        className="select-none drop-shadow-[0_2px_10px_rgba(124,58,237,0.35)]"
        draggable="false"
      />
      {withText && (
        <span className="font-display font-extrabold tracking-tight text-[#F8FAFC] text-lg leading-none">
          OMNIVERSE
        </span>
      )}
    </span>
  );
}
